import {Component, inject} from '@angular/core';
import {Observable} from 'rxjs';
import {User} from '@spartacus/core';
import {UserAccountFacade} from '@spartacus/user/account/root';
import {AsyncPipe} from '@angular/common';

@Component({
  selector: 'dcp-order-confirmation-buyer-email',
  templateUrl: './order-confirmation-buyer-email.component.html',
  imports: [AsyncPipe],
})
export class OrderConfirmationBuyerEmailComponent {
  userFacade = inject(UserAccountFacade);
  user$: Observable<User> = this.userFacade.get() as Observable<User>;
}
